export const i18nAssetPage = {
  sections: {
    alarms_list: 'Alarms history',
    event_list: 'Events history',
  },
  components: {
    upload_assets_tree: 'No registered assets. Start creating your asset tree.',
    add_asset: 'Add asset',
    upload_csv: 'Upload CSV',
    upload_tags: 'Upload tags CSV',
  },
  message: {
    asset_not_found: {
      title: 'Asset not found',
      message: 'Please try with a valid asset id',
    },
    generic_error: {
      title: 'Ops..',
      message: 'Unexpected error occurred. Try again on few minutes',
    },
  },
};
